import {
    QueryKey,
    UseQueryOptions,
    UseQueryResult,
    useQuery,
} from "react-query";

import { AmazonEtd, IAsinOption } from "../../utils/api";
import { useAuth } from "../useAuth";

type TUseQueryOptions<
    TQueryFnData,
    TError,
    TData,
    TQueryKey extends QueryKey,
> = Omit<UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>, "queryFn">;

export interface IUseGetAmazonEtdAsinsParameters {
    options?: TUseQueryOptions<any, unknown, IAsinOption[], string[]>;
}

export const useGetAmazonEtdAsins = (
    parameters: IUseGetAmazonEtdAsinsParameters = {},
): UseQueryResult<IAsinOption[], unknown> => {
    const { options } = parameters;

    const { token } = useAuth();

    if (!token) {
        throw new Error(
            "Cannot fetch Amazon ETD ASINs without authentication token",
        );
    }
    return useQuery({
        queryKey: options?.queryKey ?? ["amazon-etd-asins"],
        queryFn: async () => {
            const response = await AmazonEtd.getDistinctAsins({
                token,
            });

            return response;
        },
        ...options,
    });
};
